<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10 14.5L6 11L6.00011 7.16667L2 2H14L10.0001 7.16667L10 14.5ZM4.69344 3.33333L7.33344 6.70667V10.3867L8.66677 11.5V6.7L11.3068 3.33333H4.69344Z"
      fill="currentColor"
    />
  </svg>
</template>
